/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

/**
 * `event.visibility` — who can find an event.
 *
 * PUBLIC: listed and open to all. UNLISTED: not listed anywhere, but anyone
 * with the link can open it. PRIVATE: not listed, and the link does not open
 * it for others. The column is nullable — events saved before it existed have
 * no value — and a missing value means PUBLIC, the default.
 */
export const DEFAULT_EVENT_VISIBILITY = 'PUBLIC';

/* Built once: OrgSelect memoises on the `options` it is handed. */
export const EVENT_VISIBILITY_OPTIONS = [
  { value: 'PUBLIC', label: 'Public' },
  { value: 'UNLISTED', label: 'Unlisted' },
  { value: 'PRIVATE', label: 'Private' },
];

export const EVENT_VISIBILITY_HELP = {
  PUBLIC: 'Listed in events and the feed. Anyone can open it.',
  UNLISTED: 'Not listed anywhere. Only people with the link can open it.',
  PRIVATE: 'Not listed, and the link does not open it for others.',
};

const VALUES = EVENT_VISIBILITY_OPTIONS.map((option) => option.value);

export const isEventVisibility = (value) => VALUES.includes(value);

/** A stored value as the form holds it: anything unknown or missing is PUBLIC. */
export const normalizeEventVisibility = (value) => (
  isEventVisibility(value) ? value : DEFAULT_EVENT_VISIBILITY
);
